module.exports = __webpack_public_path__ + "img/spanish-la-liga-31.26c012b9.png";